export default "__VITE_ASSET__BUCYBQ4s__"